import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

import UserStore from './app/stores/UserStore';

import SavariaDashboard from './app/components/savariaDashboard';
import NotFound from './app/components/notFound';
import SavariaMenu from './app/components/savariaMenu';
import ProductsView from './app/components/products/productsView.react';
import UserDealerSelectView from './app/components/userDealerSelect';
import JobOverviewView from './app/components/jobs/jobOverview';
import ProductEditor from './app/components/products/productEditor';
import JobDetailEditView from './app/components/jobs/jobDetailEditView';


const Routes = (props) => {
  var u = UserStore.user() ;
  if (!u) {
    return (
      <BrowserRouter>      
        <div >     
          <Switch>              
            <Route component={NotFound} />
          </Switch>
        </div>
      </BrowserRouter>
    );
  }

  var isAdmin = UserStore.isAdministrator() ;
  var isTechSupport = UserStore.isTechSupport() ;

  return (
    <BrowserRouter>      
      <div >     
        <SavariaMenu />
        <Switch>
          <Route exact path="/" component={JobOverviewView}/>   
          {isAdmin && <Route exact path="/products/product" component={ProductEditor}/>       }
          {isAdmin && <Route exact path="/products" component={ProductsView}/>   }
          {(isAdmin || isTechSupport) && <Route exact path="/manage" component={UserDealerSelectView}/>   }
          <Route exact path="/jobs/job" component={JobDetailEditView}/>  
          <Route exact path="/jobs" component={JobOverviewView}/>        
          <Route component={NotFound} />
        </Switch>
      </div>
    </BrowserRouter>
  );
};

export default Routes;





// WEBPACK FOOTER //
// ./src/routes.js